'use strict';

angular.module('thothApp.services')
  .factory('ActivityDraft', ['$window', function ($window) {
    const KEY_PREFIX = 'sia.activityDraft.';

    const FIELDS = [
      'id', 'currentDay', 'actionType', 'description', 'clientId', 'clientName', 'ownerableType',
      'activityTypeCatalogId', 'projectId', 'projectName', 'projectCode', 'project_code', 'productId',
      'ticketId', 'ticketName', 'shortTitle', 'favorite'
    ];

    const normalize = (value) => (value === undefined || value === '' ? null : value);

    const toTime = (value) => {
      const date = value ? new Date(value) : null;
      return date && !isNaN(date.getTime()) ? date.toISOString() : null;
    };

    const pick = (item, keys) => {
      if (!item) {
        return null;
      }
      const copy = {};
      keys.forEach((key) => {
        copy[key] = normalize(item[key]);
      });
      return copy;
    };

    const storageKey = (employeeId) => KEY_PREFIX + employeeId;

    return {
      snapshot: function (activity, selections) {
        const current = activity || {};
        const selected = selections || {};
        const data = {};

        FIELDS.forEach((field) => {
          data[field] = normalize(current[field]);
        });
        data.startDate = toTime(current.startDate);
        data.endDate = toTime(current.endDate);
        data.selectedCustomer = pick(selected.customer, ['id', 'name', 'search_type']);
        data.selectedProject = pick(selected.project, ['id', 'name', 'client_id', 'client_name', 'code', 'project_code']);
        data.selectedTicket = pick(selected.ticket, ['id', 'title']);
        return data;
      },

      isDirty: function (initial, current) {
        return angular.toJson(initial) !== angular.toJson(current);
      },

      matches: function (draft, mode, activityId) {
        if (!draft || !draft.data || draft.mode !== mode) {
          return false;
        }
        return mode === 'create' || draft.activityId === activityId;
      },

      load: function (employeeId) {
        if (!employeeId) {
          return null;
        }
        try {
          const raw = $window.localStorage.getItem(storageKey(employeeId));
          return raw ? JSON.parse(raw) : null;
        } catch (error) {
          return null;
        }
      },

      save: function (employeeId, draft) {
        if (!employeeId) {
          return;
        }
        try {
          $window.localStorage.setItem(storageKey(employeeId), angular.toJson(draft));
        } catch (error) {
          // Sin almacenamiento el formulario funciona igual, solo sin borrador.
        }
      },

      clear: function (employeeId) {
        if (!employeeId) {
          return;
        }
        try {
          $window.localStorage.removeItem(storageKey(employeeId));
        } catch (error) {
          // Sin almacenamiento el formulario funciona igual, solo sin borrador.
        }
      }
    };
  }]);
